import { CoreIcon } from '../core-icon';
import bookmarkFillSVG from '../../assets/icons/bookmark-fill.svg';
import type { IconProps } from '../core-icon';

export const BookmarkFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bookmarkFillSVG} {...props} />;
};
